import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { ScoreRing } from "@/components/ScoreBadge";
import { useLang } from "@/lib/i18n";
import { ShieldCheck, ArrowRight } from "lucide-react";

export default function BadgePage() {
  const { id } = useParams();
  const { t } = useLang();
  const [b, setB] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/badge/${id}`).then(r => setB(r.data)).catch(() => setErr(true)); }, [id]);

  return (
    <div className="App min-h-screen brand-mesh">
      <Header variant="public" />
      <main className="max-w-2xl mx-auto px-6 py-20" data-testid="badge-page">
        {err && <p className="text-center text-muted-foreground">{t("badge.notfound")}</p>}
        {b && (
          <div className="hairline p-10 text-center">
            <img src="/brand/logo-icon.png" alt="EmpCo" className="h-12 mx-auto mb-6" />
            <p className="eyebrow mb-2">{t("badge.page.eyebrow")}</p>
            <h1 className="text-3xl md:text-4xl break-all mb-8" data-testid="badge-url">{b.url}</h1>
            <div className="flex justify-center mb-6"><ScoreRing score={b.score} size={180} stroke={14} /></div>
            <p className="text-sm text-muted-foreground">{t("badge.page.scanned")} {new Date(b.scanned_at).toLocaleDateString()} · {b.pages_scanned} {t("report.pages")}</p>
            <div className={`mt-4 inline-flex items-center gap-2 text-xs px-3 py-1.5 rounded-full ${b.verified ? "tag-green" : "tag-orange"}`} data-testid="badge-verified">
              <ShieldCheck className="w-3.5 h-3.5" /> {b.verified ? t("badge.page.verified") : t("badge.page.free")}
            </div>
            <p className="text-xs text-muted-foreground mt-8 leading-relaxed">{t("badge.page.disclaimer")}</p>
            <Link to="/" className="btn-primary mt-8 inline-flex" data-testid="badge-cta">{t("hero.cta")} <ArrowRight className="w-4 h-4" /></Link>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
